export default __webpack_public_path__ + "static/media/editicon.f70ff054.svg";